module.exports = __webpack_public_path__ + "media/images/flags/64/New-Caledonia-b3c24ac524d6ed8b45e7686db9603a85.png";